import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, OnDestroy, OnInit } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
/* @vite-ignore */
import { HttpResponse } from '@angular/common/http';
import { ButtonComponent, LoaderModule } from '@mds/ui';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { EpdDashboardService } from '../../services/epd-dashboard.service';
import { getResponseFilename } from '../../utils/epd-dashboard-helpers';

@Component({
  selector: 'app-epd-pep-preview',
  standalone: true,
  imports: [LoaderModule, PdfViewerModule, MatButtonModule, ButtonComponent],
  providers: [EpdDashboardService],
  templateUrl: './epd-pep-preview.component.html',
  styleUrls: ['./epd-pep-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EpdPepPreviewComponent implements OnInit, OnDestroy {
  protected cdr = inject(ChangeDetectorRef);
  protected data = inject(MAT_DIALOG_DATA);
  protected epdDashboardService = inject(EpdDashboardService);

  pdfUrl: string | null = null;
  pdfref: string;

  ngOnInit(): void {
    const { url } = this.data;

    setTimeout(() => {
      this.epdDashboardService.downloadAdditionalExports(url).subscribe((response: HttpResponse<Blob>) => {
        this.pdfref = getResponseFilename(response) || '';

        this.pdfUrl = URL.createObjectURL(response.body);

        this.cdr.markForCheck();
      });
    }, 100);
  }

  ngOnDestroy() {
    if (this.pdfUrl) URL.revokeObjectURL(this.pdfUrl);
  }

  export() {
    if (!this.pdfUrl) return;

    const anchor = document.createElement('a');
    anchor.href = this.pdfUrl;
    anchor.setAttribute('download', this.pdfref || '');
    anchor.click();
    setTimeout(() => {
      anchor.remove();
      URL.revokeObjectURL(this.pdfUrl);
    }, 100);
  }
}
